import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const Home = () => {

  const contacts = useSelector(state => state);

  const dispatch = useDispatch();

  const deleteContact = (id) => {
    dispatch({type: "DELETE_CONTACT", payload:id});
    toast.success("Contact deleted successfully !!");
  }

  return (
    <div className="container-fluid my-5">
        <div className="row">
            <div className="col-md-9 mx-auto">
                <div className="col-md-12 my-2 d-flex justify-content-end mb-4">
                    <Link to="/add" className="btn btn-outline-light">Add New Contact</Link>
                </div>
                <div className="row">
                  {
                    contacts.map((contact, id) => (
                      <div key={id} className="col-xl-6 col-lg-6 col-md-6 mb-xl-4 mb-lg-4 mb-3">
                        <div className="card text-white p-4">
                          <div className="row d-flex align-items-center">
                            <div className="col-xl-10">
                              <div className="data">Num: <span className="inner_data">{id + 1}</span></div>
                              <div className="data">Name: <span className="inner_data">{contact.name}</span></div>
                              <div className="data">Email: <span className="inner_data">{contact.email}</span></div>
                              <div className="data">Phone: <span className="inner_data"> {contact.number}</span></div>
                            </div>
                            <div className="col-xl-2 col-lg-2 col-md-4 d-flex flex-xl-column flex-lg-column mt-xl-0 mt-3">
                              <Link to={`/edit/${contact.id}`} 
                                className="btn btn-small btn-warning mb-xl-2 me-xl-0 me-2">
                                <i class="fa-solid fa-pencil"></i>
                              </Link>
                              <button type="button" onClick={() => deleteContact(contact.id)} to={`/edit/${contact.id}`} 
                                className="btn btn-small btn-dark">
                                <i class="fa-solid fa-trash-can"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
            </div>
        </div>
    </div>
  )
}

export default Home